import React, { useEffect, useRef, useState } from 'react';

interface LazyImageProps extends Omit<React.ImgHTMLAttributes<HTMLImageElement>, 'src'> {
  src: string;
  placeholder?: React.ReactNode;
  rootMargin?: string;
}

export function LazyImage({
  src,
  alt,
  className,
  placeholder = null,
  rootMargin = '200px',
  ...imgProps
}: LazyImageProps) {
  const containerRef = useRef<HTMLImageElement>(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const element = containerRef.current;
    if (!element) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { rootMargin },
    );

    observer.observe(element);

    return () => observer.disconnect();
  }, [rootMargin]);

  return (
    <img
      ref={containerRef}
      src={isVisible ? src : undefined}
      alt={alt}
      className={className}
      loading="lazy"
      decoding="async"
      {...imgProps}
    />
  );
}
